import {Routes} from "@angular/router";
import {MyQuotesComponent} from "./my-quotes/my-quotes.component";

export const myQuotesRoutes: Routes = [
    {path: '', component: MyQuotesComponent}
];
